var loqateApi = 'KZ68-HR95-MU81-RP12';
var middlewareUrl = '//services.crockettandjones.com';
jQuery( function() {
	if (jQuery('body').hasClass('template-product')){
		initSizeGuideModal();
		splitBlockAnime();
	};
	if (jQuery('body').hasClass('template-page--shogun.default') && jQuery('.section-last-guide-nav').length){
		initLastGuideNav();
	};
	if (jQuery('body').hasClass('template-page--shogun-james') && jQuery('.section-split-scroll').length){
		initSplitScroll();
	};
	if (jQuery('body').hasClass('template-page--shogun-james') && jQuery('.productcarousel').length){
		initJamesBondRelatedCollection();
	};
    if (jQuery('body').hasClass('template-page--shogun-james-goldfinger') && jQuery('.section-split-scroll').length){
		initSplitScroll();
	};
	if (jQuery('body').hasClass('template-page--shogun-james-goldfinger') && jQuery('.productcarousel').length){
		initJamesBondRelatedCollection();
	};
	if (jQuery('body').hasClass('template-page--shogun-shoe-care') && jQuery('.productcarousel').length){
		initRelatedCollection();
	}
	if (jQuery('body').hasClass('template-index')){
		initHomepageFeaturedImage();
		initLatestArticles();
		initHomepageAnnouncementBar();
	}
	if (jQuery('body').hasClass('template-product') && jQuery('.section-posts .slick').length){
		initPdpArticles();
	}
	// Initialise forms
	initRepairForm();
	initStoreContactForm();
	initContactForm();
	initPreorderForm();

	// Initialise success & error response modals
	initSuccessModal();
	initErrorHandler();
	// Initialise separate loqate and form validation
	let contactFormValidationOptions = {
		onkeyup: false
	};
	if( Shopify.shop == "crockett-and-jones-uk.myshopify.com") {
		initContactFormLoqate(); 
		initMyAccountLoqate();	
	}
	
	jQuery( '#footer-subscribe' ).validate( contactFormValidationOptions );
	jQuery( '#blog-subscribe' ).validate( contactFormValidationOptions );
	// Announcement bar
	initAnnouncementBar();
	//Set up FAQ page
	initFAQ();
	// reCAPTCHA page functions
	initCaptchaReturn();
	initCaptchaPage();
	jQuery(document).on( 'click', '.bc-sf-search-suggestion-mobile-overlay', function(e){
		console.log('%cClicked', 'background:red;color:#fff;padding:1px 6px;');
		closeSuggestionMobile('#bc-sf-search-box-mobile', true);
	});
	jQuery( document ).on( 'input change keydown keyup', '[name="address[phone]"]', preventNonNumberInput );
    function preventNonNumberInput() {
        jQuery( this ).val( jQuery( this ).val().replace( /[^0-9+]/g, '' ) );
    }
	var lastScrollTop = 0;
    jQuery(window).scroll(function () {
        var st = jQuery(this).scrollTop();
        if (jQuery(window).scrollTop() >= 100) {
            if (st > lastScrollTop) {
                jQuery('.style-finder-cta').addClass('minimise');
            } else {
                jQuery('.style-finder-cta').removeClass('minimise');
            }
            lastScrollTop = st;
        }
    });
	  
});
function splitBlockAnime() {
	gsap.registerPlugin(ScrollTrigger);
	var pdpSlot1Img = "#section-media-content-slot1 img",
		pdpSlot2Img = "#section-media-content-slot2 img",
		pdpSlot3Img = "#section-media-content-slot3 iframe",
		pdpSlot4Img = "#section-media-content-slot4 img",
		pdpSlot5Img = "#section-media-content-slot5 img",
		pdpSlot6Img = "#section-media-content-slot6 img",
		pdpH3 = ".sections-slots .section-media-content h3";
		pdpH4 = ".sections-slots .section-media-content h4";
		pdpP = ".sections-slots .section-media-content p";
		pdpLink = ".sections-slots .section-media-content .link-more";
	
	renderElemX(pdpSlot1Img, "#section-media-content-slot1", 1);
	renderElemX(pdpSlot2Img, "#section-media-content-slot2", -1);
	renderElemX(pdpSlot3Img, "#section-media-content-slot3", -1);
	renderElemX(pdpSlot4Img, "#section-media-content-slot4", 1);
	renderElemX(pdpSlot5Img, "#section-media-content-slot5", -1);
	renderElemX(pdpSlot6Img, "#section-media-content-slot6", 1);
	
	renderElemContent(pdpH3);
	renderElemContent(pdpH4);
	renderElemContent(pdpP);
	renderElemContent(pdpLink);
}
function renderElemX(target, endTarget, direction) {
	gsap.from(target, {
		x: 500 * direction,
		opacity: 0,
		duration: 2,
		ease: "circ.out",
	    scrollTrigger: {
	    	trigger: target,
	    	once: true,
	    	endTrigger: endTarget,
	    	end: "bottom 50%+=200px",
	    	scrub: 0.5
	    }
	});
}
function renderElemContent(target) {
	gsap.utils.toArray(target).forEach(function(elem) {
		hideElem(elem);
		ScrollTrigger.create({
			trigger: elem,
			once: true,
			onEnter: function() { animateFrom(elem) }
			//onEnterBack: function() { animateFrom(elem, -1) },
			//onLeave: function() { hideElem(elem) }
		});
	});
}
function hideElem(elem) {
  gsap.set(elem, {autoAlpha: 0});
}
function animateFrom(elem, direction) {
	direction = direction || 1;
	var x = 0,
		y = direction * 100;
	
	//console.log(elem.tagName)
	if(elem.tagName == "H4") {
		y = direction * 150;
	} else if (elem.tagName == "P") {
		y = direction * 200;
	} else if (elem.classList == "link-more") {
		y = direction * 250;
	}
	elem.style.transform = "translate(" + x + "px, " + y + "px)";
	elem.style.opacity = "0";
	gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
		duration: 1.25, 
		x: 0,
		y: 0, 
		autoAlpha: 1, 
		ease: "circ.out", 
		overwrite: "auto",
		scrub: 0.5
	});
}
 
function initCaptchaPage() {
	if( window.location.hash == '#footer-subscribe' || window.location.hash == '#blog-subscribe' ) {
        localStorage.formTag = window.location.hash;
    }
    if( jQuery( '.shopify-challenge__container' ).length > 0 ) {
		jQuery( 'html, body' ).animate( { scrollTop: 0 }, 0 );
	};
}
function initCaptchaReturn() {
	if( localStorage.formTag != null && jQuery( '#g-recaptcha' ).length == 0 ) {
		jQuery( window ).on( 'load', function() {
			localStorage.removeItem( 'formTag' );
			scrollToForm();
		});
		scrollToForm();
	}
}
function scrollToForm() {
	jQuery( 'html, body' ).animate( { scrollTop: jQuery( localStorage.formTag ).parents( '.subscribe__container' ).offset().top - jQuery( '.header__body' ).outerHeight() }, 0 );
	let $formField = jQuery( localStorage.formTag ).find( '[name="contact[email]"]' );
	if( $formField.length > 0 && $formField.val().length > 0 ) {
		let $formValidation = jQuery( localStorage.formTag ).validate();
		$formValidation.showErrors( { 'contact[email]': jQuery( '.subscribe__content:first' ).data( 'error' ) } );
	}
}
function initFAQ() {
	if( jQuery( '#page-faq' ).length > 0 ) {
		jQuery(".faq-anchor").click(function(e){
			e.preventDefault();
			var hash = jQuery(this.hash);
			
			jQuery('html,body').animate({scrollTop: 100}, 0, function(){
				var stickyHeaderElementHeight = jQuery('header.header').outerHeight() - 10;
				jQuery('html,body').animate({scrollTop:hash.offset().top - stickyHeaderElementHeight}, 200);
			});
		});
		jQuery(".classic-link").click(function(e) {
			e.preventDefault();
			jQuery("html, body").animate({ scrollTop: 0 }, "slow");
		});
	}
}
function initAnnouncementBar() {
	let announcementBarText = jQuery( '.announcement-bar__content' ).text().trim();
	jQuery( document ).on( 'click', '.announcement-bar__close', function( e ) {
		e.preventDefault();
		localStorage.seenAnnouncement = announcementBarText;
	});
	if( localStorage.seenAnnouncement == null || localStorage.seenAnnouncement != announcementBarText ) {
		jQuery( '.announcement-bar' ).addClass( 'open' );
		jQuery( document ).trigger( 'resize' );
	}
}
function initHomepageAnnouncementBar() {
	let homepageAnnouncementBarText = jQuery( '.homepage-announcement-bar__content' ).text().trim();
	jQuery( document ).on( 'click', '.homepage-announcement-bar__close', function( e ) {
		e.preventDefault();
		localStorage.seenHomepageAnnouncement = homepageAnnouncementBarText;
		jQuery( '.homepage-announcement-bar' ).removeClass( 'open' );
	});
	if( localStorage.seenHomepageAnnouncement == null || localStorage.seenHomepageAnnouncement != homepageAnnouncementBarText ) {
		jQuery( '.homepage-announcement-bar' ).addClass( 'open' );
		jQuery( document ).trigger( 'resize' );
	}
	if (jQuery('.header .header__inner')[0]) {
		var headerAnnouncementBar = 0;
		var headerHeight = jQuery('.header .header__inner').outerHeight();
		
		if (jQuery('.homepage-announcement-bar')[0]) {
			headerAnnouncementBar = jQuery('.homepage-announcement-bar').outerHeight();
		}
		jQuery('.homepage-featured-image').css('margin-top', (headerHeight + headerAnnouncementBar) * -1);
	}
}
function initPdpArticles() {
	var section = jQuery('#shopify-section-product-posts .section-posts');
	var status = section.find('.paginginfo');
	var slickElement = section.find('.slick');
	slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		var i = (currentSlide ? currentSlide : 0) + 1;
		status.text(i + '/' + slick.slideCount);
		if (!(jQuery(this).find('.slick-slide').length > 1)) {
			jQuery(this).find('.slick-dots').hide();
			section.find('.paginginfo').hide();
		}
		if(slick.slideCount <= slick.options.slidesToShow) {
			section.addClass('slick-no-slide');
		}
		else {
			section.removeClass('slick-no-slide');
		}
	});
	slickElement.slick({
		slidesToShow: 3,
		arrows: true,
		dots: true,
		centerMode: true,
		infinite: true,
		swipeToSlide: true,
		cssEase: 'linear',
		touchThreshold: 10,
		speed: 100,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}
		]
	});
}
function initLatestArticles() {
	var section = jQuery('section.latest-articles-carousel');
	var status = section.find('.paginginfo');
	var slickElement = section.find('.slick');
	slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		var i = (currentSlide ? currentSlide : 0) + 1;
		status.text(i + '/' + slick.slideCount);
		if (!(jQuery(this).find('.slick-slide').length > 1)) {
			jQuery(this).find('.slick-dots').hide();
			section.find('.paginginfo').hide();
		}
		if(slick.slideCount <= slick.options.slidesToShow) {
			section.addClass('slick-no-slide');
		}
		else {
			section.removeClass('slick-no-slide');
		}
	});
	slickElement.slick({
		slidesToShow: 3,
		arrows: true,
		dots: true,
		centerMode: true,
		infinite: true,
		swipeToSlide: true,
		cssEase: 'linear',
		touchThreshold: 10,
		speed: 100,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}
		]
	});
}
function initJamesBondRelatedCollection() {
	var section = jQuery('section.productcarousel');
	var status = section.find('.paginginfo');
	var slickElement = section.find('.slick');
	slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		var i = (currentSlide ? currentSlide : 0) + 1;
		status.text(i + '/' + slick.slideCount);
		if (!(jQuery(this).find('.slick-slide').length > 1)) {
			jQuery(this).find('.slick-dots').hide();
			section.find('.paginginfo').hide();
		}
		if(slick.slideCount <= slick.options.slidesToShow) {
			section.addClass('slick-no-slide');
		}
		else {
			section.removeClass('slick-no-slide');
		}
	});
	slickElement.slick({
		slidesToShow: 3,
		arrows: true,
		dots: true,
		centerMode: true,
		infinite: true,
		swipeToSlide: true,
		cssEase: 'linear',
		touchThreshold: 10,
		speed: 100,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 1279,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}
		]
	});
}
function initRelatedCollection() {
	var section = jQuery('section.productcarousel');
	var status = section.find('.paginginfo');
	var slickElement = section.find('.slick');
	slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		var i = (currentSlide ? currentSlide : 0) + 1;
		status.text(i + '/' + slick.slideCount);
		if (!(jQuery(this).find('.slick-slide').length > 1)) {
			jQuery(this).find('.slick-dots').hide();
			section.find('.paginginfo').hide();
		}
		if(slick.slideCount <= slick.options.slidesToShow) {
			section.addClass('slick-no-slide');
		}
		else {
			section.removeClass('slick-no-slide');
		}
	});
	slickElement.slick({
		slidesToShow: 3,
		arrows: true,
		dots: true,
		centerMode: true,
		infinite: true,
		swipeToSlide: true,
		cssEase: 'linear',
		touchThreshold: 10,
		speed: 100,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 1279,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					arrows: false
				}
			}
		]
	});
}
function initSplitScroll() {
	jQuery(window).on("load resize", function (e) {
		jQuery(".section-split-scroll").each(function () {
			jQuery(this).find(".content-image").css("height", jQuery(this).height() + "px");
		});
	});
	jQuery(window).on("load resize scroll", function (e) {
		jQuery(".section-split-scroll").each(function () {
			checkElementPos(jQuery(this));
		});
	});
	function checkElementPos(element) {
		var elmCard = element.find(".cardwrapper");
		var total = elmCard.find(".card").length;
		for (var i = 1; i <= total; i++) {
			var elm = element.find(".content-text .split-text:nth-child(" + i + ") .inner");
			var elmCardIndex = elmCard.find(".card:nth-child(" + i + ")");
			var isIn = isElementVisible(elm);
			if (isIn) {
				elmCard.find(".card").removeClass("active");
				if (elmCardIndex.hasClass("active")) {
					//Do nothing
				} else {
					elmCardIndex.addClass("active");
				}
			}
		}
	}
	function isElementVisible(el) {
		var rect = el[0].getBoundingClientRect(),
			vWidth = window.innerWidth || doc.documentElement.clientWidth,
			vHeight = window.innerHeight || doc.documentElement.clientHeight,
			efp = function (x, y) {
				return document.elementFromPoint(x, y);
			};
		// Return false if it's not in the viewport
		if (
			rect.right < 0 ||
			rect.bottom < 0 ||
			rect.left > vWidth ||
			rect.top > vHeight
		)
		return false;
		// Return true if any of its four corners are visible
		return (
			el[0].contains(efp(rect.left, rect.top)) ||
			el[0].contains(efp(rect.right, rect.top)) ||
			el[0].contains(efp(rect.right, rect.bottom)) ||
			el[0].contains(efp(rect.left, rect.bottom))
		);
	}    
}
function initLastGuideNav() {
	console.log("Loaded last guide");
	jQuery(document).on( 'click', '.section-last-guide-nav__menu-title:not(.active)', function(e){
		e.preventDefault();
		let dataPanel = jQuery(this).data('panel');
		console.log(dataPanel);
		jQuery('.section-last-guide-nav .section-last-guide-nav__panel .panel').removeClass('active');
		jQuery('.section-last-guide-nav .section-last-guide-nav__panel .panel.'+ dataPanel +'').addClass('active');
		jQuery('.section-last-guide-nav__menu-title').removeClass('active');
		jQuery(this).addClass('active');
		jQuery('.section-last-guide-nav').removeClass('active').addClass('active');
	});
	jQuery(document).on( 'click', '.section-last-guide-nav__menu-title.active', function(e){
		e.preventDefault();
		let dataPanel = jQuery(this).data('panel');
		console.log(dataPanel);
		jQuery('.section-last-guide-nav .section-last-guide-nav__panel .panel.'+ dataPanel +'').removeClass('active');
		jQuery(this).removeClass('active');
		jQuery('.section-last-guide-nav').removeClass('active');
	});
	jQuery(document).on( 'click', '.section-last-guide-nav__panel-inner a', function(e){
		e.preventDefault();
		jQuery('.section-last-guide-nav').removeClass('active');
		jQuery('.section-last-guide-nav__menu-title').removeClass('active');
		jQuery('.section-last-guide-nav__panel .panel').removeClass('active');
		var dest = jQuery(this).attr('href');
		var destScroll = jQuery(dest).offset().top - jQuery('.header').outerHeight() + 1;
		var st = window.pageYOffset || document.documentElement.scrollTop;
		if (st > destScroll) {
			destScroll = destScroll - 47;
			console.log("Up");
		}
		
		jQuery('html,body').animate({ scrollTop: destScroll}, 'slow');
	});
	//Sticky header logic
	var stickyElement = jQuery('.section-last-guide-nav');
	var stickyElementHeight = stickyElement.outerHeight();
	var stickyLastScrollTop = stickyElement.offset().top;
	var secondHeaderElementHeight = jQuery('.header .nav-secondary').outerHeight();
	
	var checkHeader = function(){
		var mainHeaderElementHeight = jQuery('.header').outerHeight();
		var st = window.pageYOffset || document.documentElement.scrollTop;
		var offset = 0;
		
		/*
		if (stickyElement.hasClass('active')) {
			offset = jQuery('.section-last-guide-nav .section-last-guide-nav__panel').outerHeight();
		} else {
			offset = 0;
		}
		*/
		//console.log(st +"  "+ stickyLastScrollTop);
		if( st > ((stickyLastScrollTop + offset) - mainHeaderElementHeight) ){
			//console.log("STICK");
			stickyElement.addClass('is-sticky');
			stickyElement.parent().css({'display': 'block', 'height': (stickyElementHeight + offset) +'px'});
			if( this.oldScroll > this.scrollY ) {
				//Scroll UP
				//console.log("UP");
				
				stickyElement.css({'border-top': '1px solid #cbcbcb'});
				stickyElement.css({'top': (mainHeaderElementHeight + secondHeaderElementHeight - 1) +'px'});
			} else {
				//Scroll DOWN
				//console.log("DOWN");
				stickyElement.css({'border-top': 'none'});
				stickyElement.css({'top': mainHeaderElementHeight +'px'});
			}
		} else {
			//console.log("NO STICK");
			stickyElement.removeClass('is-sticky');
			stickyElement.parent().css({'display': 'block', 'height': 'auto'});
			stickyElement.css({'border-top': 'none'});
			stickyElement.css({'top': 'auto'});
		}
		this.oldScroll = this.scrollY;
	};
	// Run the checkHeader function every time you scroll
	window.addEventListener('scroll', checkHeader);
}
function initRepairLoqate() {
	let fields = [
		{ element: "repair-address1", field: "Line1" },
		{ element: "repair-address2", field: "Line2" },
		{ element: "repair-address3", field: "City" },
		{ element: "repair-postcode", field: "PostalCode" },
		{ element: "repair-country", field: "CountryName" }		
	];
	let options = {
		key: loqateApi
	};
	return new pca.Address( fields, options );
}
function initStoreLoqate() {
	let fields = [
		{ element: "store-address1", field: "Line1" },
		{ element: "store-address2", field: "Line2" },
		{ element: "store-address3", field: "City" },
		{ element: "store-postcode", field: "PostalCode" },
		{ element: "store-country", field: "CountryName" }		
	];
	let options = {
		key: loqateApi
	};
	return new pca.Address( fields, options );
}
function initMyAccountLoqate() {
	if( jQuery( 'section.section-account' ).length > 0 ) {
		let fields = [
			{ element: "address[address1]", field: "Line1" },
			{ element: "address[address2]", field: "Line2" },
			{ element: "address[city]", field: "City" },
			{ element: "address[zip]", field: "PostalCode" },
			{ element: "address[country]", field: "CountryName" }		
		];
	
		let options = {
			key: loqateApi
		};
		let myAccountLoqate = new pca.Address( fields, options );
		myAccountLoqate.listen( "populate", function( address, variations ) {
			jQuery( '.form--address input' ).trigger('change');
		});
		jQuery( '.form--address input' ).alphanum({
            allow              : "!\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ",
            allowOtherCharSets : false
        });
		jQuery( '.form--address input' ).on( 'input change', function(){
			jQuery( this ).val( jQuery( this ).val().replace( /,/g, '.' ) );
		});
	}
}
function initContactFormLoqate() {
	if( jQuery( 'form#contact_form' ).length > 0 ) {
		let fields = [
			{ element: "field-contact-address1", field: "Line1" },
			{ element: "field-contact-address2", field: "Line2" },
			{ element: "field-contact-address3", field: "City" },
			{ element: "field-contact-postcode", field: "PostalCode" },
			{ element: "field-contact-country", field: "CountryName" }
		];
		let options = {
			key: loqateApi
		};
		var contactFormPca = new pca.Address( fields, options );
	}
}
function initHomepageFeaturedImage() {
	let slickElement = jQuery('.homepage-featured-image__slider');
	slickElement.slick({
		slidesToShow: 1,
		arrows: true,
		dots: false,
		fade: true,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 750,
		pauseOnHover: false,
		pauseOnFocus: false
	});
}
function formCallback( token ) {
	jQuery( '#modal-display-inner form [name=g-recaptcha-response]' ).remove();
	jQuery( '<input type="hidden" name="g-recaptcha-response" value="' + token + '" />' ).appendTo( '#modal-display-inner form' );
	jQuery( '#modal-display-inner form' ).get( 0 ).submit();
}
function initRepairForm() {
	// Only execute on repairs page @TODO find a better method for this
	if( location.pathname != '/pages/repairs' ) {
		return;
	}
	jQuery( document ).on( 'change', '#repair_image', function( e ) {
		if( e.target.files && e.target.files[ 0 ] ) {
			let file = e.target.files[ 0 ];
			if( /^image\//i.test( file.type ) ) {
				readFile( file );
			} else {
				alert( 'Not a valid image!' );
			}
		}
	});
	jQuery( document ).on( 'submit', '#repair_form', function( e ) {
		// Prevent default submission
		e.preventDefault();
		// Set redirect
		jQuery( this ).find( '[name=redirect]' ).remove();
		jQuery( '<input type="hidden" name="redirect">' ).val( window.location.href.replace( window.location.search, '' ) ).appendTo( this );
		// Submit
		if( jQuery( this ).valid() ) {
			grecaptcha.execute();
		}
	});
	jQuery( document ).on( 'click', '.repair-image-remove', function( e ) {
		e.preventDefault();
		jQuery( this ).parents( '.repair-image' ).remove();
	});
	// Bind modal click handlers
	// @TODO define this properly with classes
	jQuery( document ).on( 'click', 'a[href="#open-modal_repair-form-modal"]', displayRepairModal );
	jQuery( '#repair_form' ).validate();
}
function initStoreContactForm() {
	jQuery( document ).on( 'submit', '#store_form', function( e ) {
		e.preventDefault();
		jQuery( '#store_form #subject' ).val( jQuery( '#store_code option:selected' ).text() );
		// Set redirect
		jQuery( this ).remove( '[name=redirect]' );
		jQuery( '<input type="hidden" name="redirect">' ).val( window.location.href.replace( window.location.search, '' ) ).appendTo( this );
		if( jQuery( this ).valid() ) {
			grecaptcha.execute();
		}
	});
	jQuery( 'a[data-storeid]' ).on( 'click', displayStoreContactModal );
	jQuery( '#store_form' ).validate();
}
function initContactForm() {
	if( jQuery( 'form#contact_form' ).length > 0 ) {
		jQuery( 'form#contact_form' ).validate();
		jQuery( document ).on( 'click', 'form#contact_form .form__btn', function( e ) {
			// Don't do anything if we are not valid
			if( !jQuery( 'form#contact_form' ).valid() ) {
				return false;
			} else {
				jQuery( 'form#contact_form' ).submit();
			}
			
		});
	}
	if( jQuery( '.form__message' ).length > 0 ) { 
		scrollToFormMessage();
		
		jQuery( window ).on( 'load', function(){
			setTimeout( function(){
				scrollToFormMessage();
			}, 1 );
		});
	}
}
function scrollToFormMessage() {
	let scrollTarget = jQuery( '.form.form--contact' );
	jQuery( 'html, body' ).animate( { scrollTop: scrollTarget.position().top - jQuery( '.header__body' ).outerHeight() + 1}, 0 );
}
function subscribeCallback( data ) {
	jQuery( 'form#contact_form' ).get( 0 ).submit();
}
function initSuccessModal() {
	let params = new URLSearchParams( window.location.search );
	if( params.get( 'success' ) == 'true' ) {
		displayModal( '#success-message-modal' );
	}
}
function initErrorHandler() {
	let params = new URLSearchParams( window.location.search );
	if( params.get( 'success' ) == 'false' ) {
		let formId = params.get( 'form' );
		displayModal( '[data-form-id="' + formId + '"]' );
	}
}
function displayRepairModal( e ) {
	e.preventDefault();
	displayModal( '#repair-form-modal' );
	initRepairLoqate();
}
function initSizeGuideModal() {
	jQuery( '#size-guide' ).on( 'click', displaySizeGuideModal );
}
function displaySizeGuideModal( e ) {
	e.preventDefault();
	displayModal( '#size-modal' );
}
function displayStoreContactModal( e ) {
	e.preventDefault();
	displayModal( '#store-contact-modal' );
	jQuery( '#store-store_code' ).val( jQuery( this ).data( 'storeid' ) );
	//initStoreLoqate();
}
function displayModal( contentSelector ) {
	// Remove extant modal wrapper & overlay, if present
	jQuery( '#modal-display-wrapper' ).remove();
	jQuery( '#modal-page-overlay' ).remove();
	// Create modal wrapper
	let $wrapper = (contentSelector != "#style-finder-modal") ? jQuery( '<div id="modal-display-wrapper"></div>' ) : jQuery( '<div id="modal-display-wrapper" class="style-guide-override"></div>' );
	let $close   = (contentSelector != "#style-finder-modal") ? jQuery( '<a href="#" class="modal-close" data-action="modal-close"><svg xmlns="http://www.w3.org/2000/svg" width="10.707" height="10.707" viewBox="0 0 10.707 10.707"><g id="Icon_Close" data-name="Icon/Close" transform="translate(0.354 0.354)"><line id="Line_118" data-name="Line 118" x2="10" y2="10" fill="none" stroke="currentColor" stroke-width="1"></line><line id="Line_119" data-name="Line 119" x1="10" y2="10" fill="none" stroke="currentColor" stroke-width="1"></line></g></svg></a>' ) : "";
	let $inner   = jQuery( '<div id="modal-display-inner"></div>' );
	$wrapper.data( 'contentSelector', contentSelector );
	// Build up the modal
	if ($close != '') {
		$close.appendTo( $wrapper );
	}
	$inner.appendTo( $wrapper );
	// Add content to modal container
	$inner.append( jQuery( contentSelector ) );
	// Append modal wrapper to body
	$wrapper.appendTo( 'body' );
	//Updated to using css position fixed method
	/*
	if( jQuery(window).width() > 767 ) {
		$wrapper.css( 'top', window.scrollY + 114 );
	} else {
		$wrapper.css( 'top', window.scrollY + 16 );
	}
	*/
	
	// Create a page cover overlay
	let $overlay = jQuery( '<div id="modal-page-overlay" data-action="modal-close"></div>' );
	$overlay.appendTo( 'body' );
	// Setup listeners to close the modal
	jQuery( '[data-action="modal-close"]' ).off( 'click' ).on( 'click', closeModal );
}
function closeModal( e ) {
	e.preventDefault();
	// Put the modal content back in its house
	let modalTarget = jQuery( '#modal-display-wrapper' ).data( 'contentSelector' );
	jQuery( modalTarget ).appendTo( '#modals-container' );
	// Remove the modal
	jQuery( '#modal-display-wrapper' ).remove();
	jQuery( '#modal-page-overlay' ).remove();
}
function readFile( file ) {
	var reader = new FileReader();
	reader.onloadend = function () {
		processFile( reader.result, file.type );
	}
	reader.onerror = function () {
		alert( 'There was an error reading the file!' );
	}
	reader.readAsDataURL( file );
}
function processFile( dataURL, fileType ) {
	var maxWidth  = 800;
	var maxHeight = 800;
	var image = new Image();
	let repairImageTemplate = jQuery( '.repair-image-template' ).html();
	let $repairImage = jQuery( '<div class="repair-image">' + repairImageTemplate + '</div>' ).appendTo(  '#repair_form .repair-images' );
	image.onload = function () {
		var canvas       = $repairImage.find( 'canvas' )[ 0 ];
		var width        = image.width;
		var height       = image.height;
		var shouldResize = ( width > maxWidth ) || ( height > maxHeight );
		var context      = canvas.getContext( '2d' );
		// Clear the canvas
		context.clearRect( 0, 0, canvas.width, canvas.height );
		if( !shouldResize ) {
			// If the image is small enough, don't resize
			canvas.width  = image.width;
			canvas.height = image.width;
			canvas.style.display = "block";
			context = canvas.getContext( '2d' );
			context.drawImage( this, 0, 0, image.width, image.height );
		} else {
			// Reisze the image
			let newWidth, newHeight;
			if( width > height ) {
				newHeight = height * ( maxWidth / width );
				newWidth  = maxWidth;
			} else {
				newWidth  = width * ( maxHeight / height );
				newHeight = maxHeight;
			}
			// Output and set the canvas image source
			canvas.width  = newWidth;
			canvas.height = newHeight;
			canvas.style.display = "block";
		
			context = canvas.getContext( '2d' );
			context.drawImage( this, 0, 0, newWidth, newHeight );
		}
		jQuery( '#repair_image' ).val( '' );
		// Add the resized image from canvas
		let dataUrl  = canvas.toDataURL( 'image/jpeg', 0.6 );
		// Add field
		let index    = jQuery( '.repair-image:last' ).index();
		let imageKey = 'image_' + index;
		jQuery( '<input type="hidden" name="' + imageKey + '">' ).val( dataUrl ).appendTo( '#repair_form' );
	};
	image.onerror = function () {
		alert( 'There was an error processing your file!' );
	};
	image.src = dataURL;
} 
// Collection Filter Sticky 
if (jQuery('body').hasClass('template-collection') || jQuery('body').hasClass('template-search')){
	if( jQuery('#collectionFilter').length > 0 ) {
		let filter = document.getElementById("collectionFilter"); 
		window.onscroll = function() {
			filterSticky(filter)
		};
	}
	if( jQuery('#collectionFilterSearch').length > 0 ) {
		let filter = document.getElementById("collectionFilterSearch"); 
		window.onscroll = function() {
			filterSticky(filter)
		};
	}
}
function filterSticky(target) {
  if (document.body.scrollTop > target.offsetTop || document.documentElement.scrollTop > target.offsetTop) {
    target.classList.add('is-sticky');
  } else {
    target.classList.remove('is-sticky');
  }
}

function statusVariant() {
	let getSize = jQuery( '#product-select-option-0' ).val();
	let currentVariantId = jQuery('#product-select option').filter(function() {
		return jQuery(this).text().trim() === getSize;
	}).val();
	let statusCurrentVariant = jQuery("input[name='variant-" + currentVariantId + "']").val();

	return statusCurrentVariant;
}


// OOS ALTERNATIVES
let statusCurrentVariant;
let query;
let product_type = jQuery("input[name='product_type']").val();

if (product_type == 'Shoes' || product_type == 'Shoe') {
	jQuery( '#product-select-option-0' ).on( 'change', function() {
		statusCurrentVariant = statusVariant();
		if (statusCurrentVariant == 'false') { // statusCurrentVariant is a string not boolean
			jQuery( '.section-product__actions .oos-container' ).remove();

			// OOS RED ALERT
			jQuery('.oos-alert').remove();
			jQuery('.section-product__form__links').prepend('<p class="oos-alert">Out of Stock</p>');
			// END OOS RED ALERT

			fetchOosOptions();
		} else {
			jQuery('.oos-alert').remove(); // OOS RED ALERT REMOVE
			jQuery( '.section-product__actions .oos-container' ).remove();
		}

		// Change text within 'Find in store' buttons
		jQuery('.js-find-store-btn span').text('Find in Store');
	});

	jQuery(window).on('load', function () {
		statusCurrentVariant = statusVariant();
		if (statusCurrentVariant == 'false') { // statusCurrentVariant is a string not boolean
			jQuery( '.section-product__actions .oos-container' ).remove();

			// OOS RED ALERT
			jQuery('.oos-alert').remove();
			jQuery('.section-product__form__links').prepend('<p class="oos-alert">Out of Stock</p>');
			// END OOS RED ALERT

			fetchOosOptions();
		}
	});
}

jQuery(document).ready(function() {
  // Check if the body has the class 'template-product'
  if (jQuery('body').hasClass('template-product')) {
    // Get the input element with class 'selectric-input'
    const inputElement = jQuery('.selectric-input');
    // Add the 'aria-hidden' attribute
    inputElement.attr('aria-hidden', 'true');
    // Add the 'type' attribute with value 'hidden'
    inputElement.attr('type', 'hidden');
  }
});

function fetchOosOptions(query_exec = 'query1') {
	// Get the current product STYLE and COLOURGROUP tags
	let styleTag       = Shopify.product.tags.filter( tag => tag.substring( 0, 6 ) == 'STYLE|' )[ 0 ];
	let colourGroupTag = Shopify.product.tags.filter( tag => tag.substring( 0, 12 ) == 'COLOURGROUP|' )[ 0 ];
	let materialTag    = Shopify.product.tags.filter( tag => tag.substring( 0, 9 ) == 'MATERIAL|' )[ 0 ];
	let genderTag    = Shopify.product.tags.filter( tag => tag.substring( 0, 7 ) == 'GENDER|' )[ 0 ];
	let fittingTag    = Shopify.product.tags.filter( tag => tag.substring( 0, 8 ) == 'FITTING|' )[ 0 ];
    let soleTag    = Shopify.product.tags.filter( tag => tag.substring( 0, 10 ) == 'SOLEGROUP|' )[ 0 ];

	// Get the selected size
	let mutation;
	let size = jQuery( '#product-select-option-0' ).val();
	
	// Call the storefront API to get a list of shoes that match the selected size and other paremeters
	if (query_exec == 'query1') {
		console.log("DEBUG: EXECUTING QUERY 1");
		mutation = `{
			products( first: 100, query: "tag:'` + styleTag +`' AND tag:'` + colourGroupTag + `' AND tag:'` + materialTag + `' AND tag:'` + genderTag + `' AND tag:'` + fittingTag + `'" ) {
				edges {
					node {
						id
						handle
						title
						tags
						productType
						metafield(namespace: "custom", key: "preorder_countdown") {
							id
							key
							value
						}
						variantBySelectedOptions(selectedOptions:[{name: "` + size_name + `", value: "` + size + `" }]) {
							availableForSale
							id
							price {
			          amount
			          currencyCode
			        }
							compareAtPrice {
			          amount
			          currencyCode
			        }
							image {
								url
							}
						}
					}
				}
			}
		}`;
	} else if (query_exec == 'query2') {
		// Gender, style & Size
		console.log("DEBUG: EXECUTING QUERY 2");
		mutation = `{
			products( first: 100, query: "tag:` + styleTag +` AND tag:` + genderTag + ` AND tag:` + fittingTag + `  AND tag:` + materialTag + `" ) {
				edges {
					node {
						id
						handle
						title
						tags
						productType
						metafield(namespace: "custom", key: "preorder_countdown") {
							id
							key
							value
						}
						variantBySelectedOptions(selectedOptions:[{name: "` + size_name + `", value: "` + size + `" }]) {
							availableForSale
							id
							price {
			          amount
			          currencyCode
			        }
							compareAtPrice {
			          amount
			          currencyCode
			        }
							image {
								url
							}
						}
					}
				}
			}
		}`;
      
	} else if (query_exec == 'query3') {
		// Gender, style
		console.log("DEBUG: EXECUTING QUERY 3");
		mutation = `{
			products( first: 100, query: "tag:` + styleTag +` AND tag:` + genderTag + ` AND tag:` + fittingTag + ` AND tag:` + soleTag + `" ) {
				edges {
					node {
						id
						handle
						title
						tags
						productType
						metafield(namespace: "custom", key: "preorder_countdown") {
							id
							key
							value
						}
						variants(first: 20) {
							edges {
								node {
									availableForSale
									id
									price {
					          amount
					          currencyCode
					        }
									compareAtPrice {
					          amount
					          currencyCode
					        }
									image {
										url
									}
								}
							}
						}
					}
				}
			}
		}`;
	}
console.log(mutation);
	const settings_oos = {
		'async': true,
		'crossDomain': true,
		'url': domain_graphql,
		'method': 'POST',
		'headers': {
		'X-Shopify-Storefront-Access-Token': storefront_access_token,
		'Content-Type': 'application/graphql',
		},
		'data': mutation
	};

	// Call the Storefront API and get the data response
	return jQuery.ajax( settings_oos ).done( fetchOosOptionsResponse );
}

function initOssCarousel(inStockProducts){
	var section = jQuery('.oos-container');
	var slickElement = section.find('.oos-options-container');

	slickElement.on("init", function(event, slick){
		jQuery('<div class="slider-product__count js-slider-product-count"></div>').appendTo(slickElement);
		var status = section.find('.js-slider-product-count');
		status.text(parseInt(slick.currentSlide + 1) + '/' + slick.slideCount);
	});

	slickElement.on("afterChange", function(event, slick, currentSlide, nextSlide){
		//console.log("currentSlide "+currentSlide);
		//console.log("nextSlide "+nextSlide);
		//console.log("slick.slideCount "+slick.slideCount);
		var status = section.find('.js-slider-product-count');
		status.text(parseInt(slick.currentSlide + 1) + '/' + slick.slideCount);

		if (!(jQuery(this).find('.slick-slide').length > 1)) {
			jQuery(this).find('.slick-dots').hide();
			section.find('.js-slider-product-count').hide();
		}

		if(slick.slideCount <= slick.options.slidesToShow) {
			section.addClass('slick-no-slide');
		}
		else {
			section.removeClass('slick-no-slide');
		}
	});

	slickElement.slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: true
	});
}

function fetchOosOptionsResponse( response ) {
	// Define our products array
	let products = response.data.products.edges;
	
	
	// For each of the returned product variants, we need those which are in stock
	let inStockProducts = products.filter(function(product) {
		if (query == 'query3') {
			// Search through all variants for availability
			for (let edge of product.node.variants.edges) {
				if (edge.node.availableForSale) {
					return true;
				}
			}
			return false; // If none are available, return false
		} else {
			let variantOptions = product.node.variantBySelectedOptions;
			if (variantOptions != undefined && variantOptions.availableForSale) {
				return true;
			}
		}
	});

	// Map function remains mostly the same, but the "variantOptions" needs special handling for 'query3'
	inStockProducts = inStockProducts.map(function(product) {
		let variantOptions;

		if (query === 'query3') {
			// Find the first available variant
			variantOptions = product.node.variants.edges.find(edge => edge.node.availableForSale).node;
		} else {
			variantOptions = product.node.variantBySelectedOptions;
		}
      

		return {
			"handle": product.node.handle,
			"title": product.node.title,
			"tags": product.node.tags,
			"productType": product.node.productType,
			"metafield": product.node.metafield,
			"image": variantOptions.image.url,
			"variantId": variantOptions.id,
			"price": variantOptions.price,
			"compare_at_price": variantOptions.compareAtPrice,
		};
	});

	
	renderOosOptions( inStockProducts );

	// Change text within 'Find in store' buttons
	jQuery('.js-find-store-btn span').text('Out of Stock Online - Find in Store');

}

function renderOosOptions(inStockProducts) {
  var oos_title = jQuery('.section-product__actions').data('oostitle');
  var oos_subtitle = jQuery('.section-product__actions').data('oossubtitle');
  const container = jQuery( '<div class="oos-container"><p class="oos-title">'+oos_title+'<span>'+oos_subtitle+'</span></p><div class="oos-options-container">' ).prependTo( '.section-product__actions .section-product__form__actions' );
  const currentDate = new Date();
  let count = 0;
  let styleTagCheck = Shopify.product.tags.filter( tag => tag.substring( 0, 6 ) == 'STYLE|' )[ 0 ];
  inStockProducts.forEach(element => {
    if (
      element.handle !== product_handle &&
      !element.tags.some(elm => elm.includes('DISCONTINUED')) &&
      element.productType !== 'Refurbishment' &&
      (!element.tags.some(elm => elm.includes('PREORDER')) || (element.metafield && currentDate <= new Date(element.metafield.value)))
    ) {
      if (count <= 9) { // Limit to 10
			if (element.tags.some(elm => elm.includes(styleTagCheck))) {
				renderOosOption(element);
				count = count + 1;
			}
      }
    }
  }); 
  
  if (count > 2){
  	initOssCarousel(inStockProducts);
  }


  if (count == 0) {
	jQuery( '.section-product__actions .oos-container' ).remove();
	if (query == null) {
		query = 'query2';
		//console.log("DEBUG: Nothing found with query 1. Calling query 2");
		fetchOosOptions(query);
	} else if (query == 'query2') {
		query = 'query3';
		//console.log("DEBUG: Nothing found with query 2. Calling " + query);
		fetchOosOptions(query);

	} else {
		//console.log("DEBUG: No products found!")
	}
  }

}

function renderOosOption( product ) { 
	let element = jQuery( '<div class="oos-option">' );
	let link = jQuery( '<a>', { 
		"href": product.handle + '?variant=' + product.variantId.match(/\d+/)[0],
		"class": "oos-suggested-item"
	});

	let colourTag = jQuery.grep(product.tags, function(element) { return element.startsWith("SHOECOLOUR|"); })[0].replace("SHOECOLOUR|", "");
	let materialTagRaw = jQuery.grep(product.tags, function(element) { return element.startsWith("MATERIALDESCRIPTION|"); })[0];
		
	if (materialTagRaw !== undefined) {
		materialTag = materialTagRaw.replace("MATERIALDESCRIPTION|", "");
	} else {
		materialTag = '';
	}

	let soleTag = jQuery.grep(product.tags, function(element) { return element.startsWith("SOLE|"); })[0].replace("SOLE|", "");
	let fullTitleProduct = colourTag + " " + materialTag + " " + soleTag.replace("COLLECTION|", "") + " Sole";
	let shortNameProduct = jQuery.grep(product.tags, function(element) { return element.startsWith("SHORTNAME|"); })[0].replace("SHORTNAME|", "");
	let imgResize = product.image+"&width=500";
	let img = jQuery( '<img src="' + imgResize + '" alt="' + product.title + '">' );
	let shortName = jQuery( '<span class="shortname">' + shortNameProduct + '</span>' );
	let title = jQuery( '<span class="title">' + fullTitleProduct + '</span>' );

	// Price Display
	let price = '';
	if (product && product.compare_at_price && product.price && product.compare_at_price.amount > product.price.amount) {
		price = jQuery( '<span class="oos-price"><span class="old-price-oos">' + currency_oos + product.compare_at_price.amount.replace( '.0', '' ) + '</span><span class="new-price-oos">' + currency_oos + product.price.amount.replace( '.0', '' ) + '</span></span>' );
	} else if (product && product.price) {
		price = jQuery( '<span class="oos-price">' + currency_oos + product.price.amount.replace( '.0', '' ) + '</span>' );
	} else {
		price = 0;
	}
	
	img.appendTo( link );
	shortName.appendTo( link );
	title.appendTo( link );
	price.appendTo( link );
	link.appendTo( element );

	// Hand grade tag
	if (product.tags.includes('COLLECTION|Hand Grade')) {
		let handGradeTag = jQuery('<img class="hand-grade-oos" role="img" src="https://crockett-and-jones-staging.myshopify.com/cdn/shop/files/p-icon-handgrade_320x.gif?v=1614073555" />');
		handGradeTag.prependTo(element)
	} 

	if (price !== 0) {
      element.appendTo( '.section-product__actions .oos-options-container' );
    }

	query = null; // Reset query position
}

// PREORDER FORM
function initPreorderForm() {
	// Only execute on preorders page
	if( location.pathname != '/pages/preorder' ) {
		return;
	}

	jQuery( document ).on( 'change', '#preorder_image', function( e ) {
		if( e.target.files && e.target.files[ 0 ] ) {
			let file = e.target.files[ 0 ];
			if( /^image\//i.test( file.type ) ) {
				readPreorderFile( file );
			} else {
				alert( 'Not a valid image!' );
			}
		}
	});

	jQuery( document ).on( 'submit', '#preorder_form', function( e ) {
		// Prevent default submission
		e.preventDefault();

		// Set redirect
		jQuery( this ).find( '[name=redirect]' ).remove();
		jQuery( '<input type="hidden" name="redirect">' ).val( window.location.href.replace( window.location.search, '' ) ).appendTo( this );

		// Submit
		if( jQuery( this ).valid() ) {
			grecaptcha.execute();
		}
	});

	jQuery( document ).on( 'click', '.preorder-image-remove', function( e ) {
		e.preventDefault();

		jQuery( this ).parents( '.preorder-image' ).remove();
	});

	// Bind modal click handlers
	// @TODO define this properly with classes
	jQuery( document ).on( 'click', 'a[href="#open-modal_preorder-form-modal"]', displayPreorderModal );
	jQuery( '#preorder_form' ).validate();
}

function displayPreorderModal( e ) {
	e.preventDefault();
	displayModal( '#preorder-form-modal' );
	initPreorderLoqate();
}

function initPreorderLoqate() {
	let fields = [
		{ element: "preorder-address1", field: "Line1" },
		{ element: "preorder-address2", field: "Line2" },
		{ element: "preorder-address3", field: "City" },
		{ element: "preorder-postcode", field: "PostalCode" },
		{ element: "preorder-country", field: "CountryName" }		
	];

	let options = {
		key: loqateApi
	};

	return new pca.Address( fields, options );
}

function processPreorderFile( dataURL, fileType ) {
	var maxWidth  = 800;
	var maxHeight = 800;

	var image = new Image();

	let preorderImageTemplate = jQuery( '.preorder-image-template' ).html();
	let $preorderImage = jQuery( '<div class="preorder-image">' + preorderImageTemplate + '</div>' ).appendTo(  '#preorder_form .preorder-images' );

	image.onload = function () {
		var canvas       = $preorderImage.find( 'canvas' )[ 0 ];
		var width        = image.width;
		var height       = image.height;
		var shouldResize = ( width > maxWidth ) || ( height > maxHeight );
		var context      = canvas.getContext( '2d' );

		// Clear the canvas
		context.clearRect( 0, 0, canvas.width, canvas.height );

		if( !shouldResize ) {
			// If the image is small enough, don't resize
			canvas.width  = image.width;
			canvas.height = image.width;
			canvas.style.display = "block";

			context = canvas.getContext( '2d' );
			context.drawImage( this, 0, 0, image.width, image.height );
		} else {
			// Reisze the image
			let newWidth, newHeight;

			if( width > height ) {
				newHeight = height * ( maxWidth / width );
				newWidth  = maxWidth;
			} else {
				newWidth  = width * ( maxHeight / height );
				newHeight = maxHeight;
			}

			// Output and set the canvas image source
			canvas.width  = newWidth;
			canvas.height = newHeight;
			canvas.style.display = "block";
		
			context = canvas.getContext( '2d' );
			context.drawImage( this, 0, 0, newWidth, newHeight );

		}

		jQuery( '#preorder_image' ).val( '' );

		// Add the resized image from canvas
		let dataUrl  = canvas.toDataURL( 'image/jpeg', 0.6 );

		// Add field
		let index    = jQuery( '.preorder-image:last' ).index();
		let imageKey = 'image_' + index;

		jQuery( '<input type="hidden" name="' + imageKey + '">' ).val( dataUrl ).appendTo( '#preorder_form' );
	};

	image.onerror = function () {
		alert( 'There was an error processing your file!' );
	};

	image.src = dataURL;
} 

function readPreorderFile( file ) {
	var reader = new FileReader();

	reader.onloadend = function () {
		processPreorderFile( reader.result, file.type );
	}

	reader.onerror = function () {
		alert( 'There was an error reading the file!' );
	}

	reader.readAsDataURL( file );
}
